<template>
  <!-- Dry-run preview: what the sheet WOULD do, before anything is written -->
  <div v-if="previewing" class="flex items-center gap-2 text-xs text-gray-500 mt-3" data-testid="score-preview-loading">
    <i class="pi pi-spin pi-spinner"></i> Checking the sheet…
  </div>
  <div v-else-if="previewError" class="text-xs text-red-600 bg-red-50 border border-red-200 rounded-lg px-3 py-2 mt-3"
    data-testid="score-preview-error">
    <i class="pi pi-times-circle mr-1"></i>{{ previewError }}
  </div>
  <div v-else-if="summary" class="border rounded-lg px-3 py-2 mt-3 text-xs bg-white" data-testid="score-preview-panel">
    <p class="font-semibold mb-1" :class="summary.saved > 0 ? 'text-green-700' : 'text-red-600'">
      <i :class="summary.saved > 0 ? 'pi pi-check-circle' : 'pi pi-times-circle'" class="mr-1"></i>
      <template v-if="summary.saved > 0">
        {{ summary.saved }} score(s) for {{ summary.students }} student(s) ready to import.
      </template>
      <template v-else>Nothing in this sheet can be imported.</template>
    </p>
    <ul v-if="lines.length" class="text-gray-600 space-y-0.5 mb-1">
      <li v-for="line in lines" :key="line"><i class="pi pi-minus text-[8px] mr-1"></i>{{ line }}</li>
    </ul>
    <p class="text-gray-400">Nothing has been saved yet — review and confirm below.</p>
  </div>
</template>

<script setup lang="ts">
import type { ScoreImportSummary } from '@/composables/useScoreEntry';
import { previewIssueLines } from './scoreUploadSummary';

const props = defineProps<{
  previewing: boolean;
  previewError: string | null;
  summary: ScoreImportSummary | null;
  isCourseContext?: boolean;
}>();

const lines = computed(() => previewIssueLines(props.summary, !!props.isCourseContext));
</script>
